import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DashboardHttpService } from '../../../core-services/dashboard-http-service/dashboard-http.service';
import {
  ClassicCompositeKey, EntitiesUserInfo,
  GetEntitiesUserInfoRequest,
  LookupEntityIdsByClassicIdsResponse,
  Paged,
  ShortenUrl,
  ShortenUrlRequest
} from '../../dtos/api';
import {map, switchMap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesApiService {

  constructor(private http: DashboardHttpService) { }

  shortenUrl(urlsToShorten: ShortenUrlRequest[]) {
    let url = `${environment.apiUrl}/utilities/shorten-urls`;
    return this.http.post<{urls: string}, ShortenUrl[]>(url, { urls: JSON.stringify(urlsToShorten) });
  }

  lookupEntityIdsByClassicIds(classicCompositeKeys: ClassicCompositeKey[]) {
    let url = `${environment.apiUrl}/utilities/lookup-entity-ids-by-classic-ids`;
    return this.http.postWithOptions<LookupEntityIdsByClassicIdsResponse>(url, {json: classicCompositeKeys});
  }

  getUsersInformationForEntities(requestBody: GetEntitiesUserInfoRequest) {
    let url = `${environment.apiUrl}/utilities/emails`;
    let requestBodyFinalized = {...requestBody, json: JSON.stringify(requestBody.json)};
    return this.http.postWithOptions<Paged<EntitiesUserInfo>>(url, requestBodyFinalized);
  }

  getAllUsersInformationForEntities(extraParams: GetEntitiesUserInfoRequest) {
    let initialRequestBody: GetEntitiesUserInfoRequest = {
      limit: 1000,
      page: 1,
      ...extraParams
    };

    return this.getUsersInformationForEntities(initialRequestBody).pipe(
        switchMap(initialResponse => {
          let total_pages = Math.ceil(initialResponse.total_items / initialResponse.items_per_page);
          let requests: Observable<Paged<any>>[] = [];
          for (let i = 2; i <= total_pages; i++) {
            let nextParams = {
              limit: 1000,
              page: i,
              ...extraParams
            };
            requests.push(this.getUsersInformationForEntities(nextParams));
          }

          if (requests.length > 0) {
            return forkJoin(requests).pipe(
                map(forkResponse => initialResponse.items.concat(...forkResponse.map(x => x.items))));
          }
          return of(initialResponse.items);
        }));

  }

}
